import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-hyperlink",
    templateUrl: "./hyperlink.component.html",
    styleUrls: ["./hyperlink.component.scss"],
    standalone: false
})
export class HyperlinkComponent {
  @Input() label: string = "";
  @Input() disabled: boolean = false;

  constructor() {}
}
